export default __webpack_public_path__ + "static/media/brackets_logo_nav.71d1a4f4.svg";